<template>
  <div class="accordion" :class="{ 'accordion--open': open }">
    <component
      :is="tag"
      type="button"
      class="accordion__header"
      @click="toggle"
    >
      <slot name="header" />
      <div v-if="shouldShowArrow" class="accordion__arrow">
        <i :class="arrowIcon" />
        <span class="u__visually-hidden">Open</span>
      </div>
    </component>
    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div v-show="shouldOpen" class="accordion__body" :aria-hidden="!open">
        <slot name="body" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  inject: ["mq"],
  props: {
    showArrow: {
      type: Boolean,
      default: false,
    },
    openByDefault: {
      type: Boolean,
      default: false,
    },
    disableDesktop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: this.openByDefault,
    };
  },
  computed: {
    arrowIcon() {
      return this.open ? "icon-arrow-up" : "icon-arrow-down";
    },
    tag() {
      if (this.disableDesktop && this.mq.mdPlus) {
        return "div";
      }

      return "button";
    },
    shouldShowArrow() {
      if (this.disableDesktop && this.mq.mdPlus) {
        return false;
      }

      return this.showArrow;
    },
    shouldOpen() {
      if (this.disableDesktop && this.mq.mdPlus) {
        return true;
      }

      return this.open;
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    enter(element) {
      element.style.height = "auto";

      const height = getComputedStyle(element).height;

      element.style.height = 0;

      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-enter-active,
.expand-leave-active {
  transition: height 150ms ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}

.accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: $heading-font-family;
}

.accordion__arrow {
  font-size: 20px;
}
</style>
